import * as React from 'react';
import useAddAnimationClassnames from './useAddAnimationClassnames.esm.js';

var AnimationContext = React.createContext({
    initAnimationForElement: function () {
        return;
    },
});
/**
 * The wrapper with Animation context.
 * Used for the parent components to add animation by default and provide the manual animation trigger for element.
 * Usage:
 * <AnimationContextWrapper>
 *    <ParentComponent/>
 * </AnimationContextWrapper>
 *
 * Child components now have access to useTriggerAnimationInit hook. Please look up useTriggerAnimationInit for the hook usage.
 */
var AnimationContextWrapper = function (_a) {
    var children = _a.children;
    //useAddAnimationClassnames hook automatically scans the webpage for rendered elements and adds the animation
    //returned initAnimationForElement is the function used in useTriggerAnimationInit hook to trigger animation to selected component
    var initAnimationForElement = useAddAnimationClassnames().initAnimationForElement;
    return React.createElement(AnimationContext.Provider, { value: { initAnimationForElement: initAnimationForElement } }, children);
};

export { AnimationContext, AnimationContextWrapper as default };
//# sourceMappingURL=animationContext.esm.js.map
